import React from 'react';

import { DateUtil } from '../../../utils/date-util';
import { CondensedSmall } from '../../content/CondensedSmall/CondensedSmall';
import { Badge } from '../../element/Badge/Badge';

import type { FocusAreaBarsExperienceType } from './focus-area-bars.types';

export type FocusAreaBarsExperienceProps = {
  name?: string;
  experiences: FocusAreaBarsExperienceType[];
};

export const FocusAreaBarsExperience = ({
  name = 'FOCUS_AREA_BARS_EXPERIENCE',
  experiences,
}: FocusAreaBarsExperienceProps) => {
  const sortedExperiences = [...experiences].sort((a, b) =>
    a.client.localeCompare(b.client, undefined, { sensitivity: 'base' })
  );

  return (
    <ul data-test={name}>
      {sortedExperiences.map(exp => (
        <li key={exp.client}>
          {exp.isAxiom ? (
            <Badge background="orange" name={`${name}_AXIOM_BADGE`}>
              <CondensedSmall>Axiom</CondensedSmall>
            </Badge>
          ) : null}
          <CondensedSmall name={`${name}_TEXT`}>
            {exp.client}; {DateUtil.formatAsYear(exp.startDate)}-
            {DateUtil.formatAsYear(exp.endDate ?? new Date())}
          </CondensedSmall>
        </li>
      ))}
    </ul>
  );
};
